import React from "react";
import { LinearProgress, Dialog, DialogContent } from '@mui/material';

export default class LoadProgress extends React.Component {
  render() {
    return (
      <Dialog
        open={this.props.open}
        fullScreen={false}
      >
        <DialogContent style={{ textAlign: 'center', padding: '30px' }}>
          <div style={{ minWidth: '400px', minHeight: '50px' }}>
            Please Wait..
            <LinearProgress color="success" />

          </div>
        </DialogContent>
      </Dialog>
    )

  }
}